import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from 'store/actions/pinpad';

const initialState = {
  params: {
    functionId: 3,
    trnAmount: 0,
    taxInvoiceNumber: '1234',
    taxInvoiceDate: '20180611',
    taxInvoiceTime: '170000',
    cashierOperator: 'CAIXA',
    trnAdditionalParameters: '',
    trnInitParameters: '',
    terminalId: 'REST0001',
    storeId: '00000000',
    sitefIp: '127.0.0.1',
    sessionId: '',
    continue: 0,
    functionSelected: 3,
  },
};

export const PinpadReducer = createReducer(initialState).handleAction(
  actions.getPinpadLogin.success,
  (state: any, { payload }: any) => {
    return {
      ...state,
      params: {
        ...state.params,
        sitefIp: payload.sitefIp,
        storeId: payload.storeId,
      },
    };
  },
);
